import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addContact: 'Add a contact',
    city: 'City',
    companyName: 'Company name',
    contacts: 'Contacts',
    country: 'Country',
    deleteContact: 'Delete',
    findClientDescription:
      'Find your client by name or SIRET. We will automatically fill its information',
    legalRegistrationNumber: 'SIRET or SIREN number',
    searchInputLabel: 'Look for your client',
    searchInputPlaceholder: 'Name, SIREN or SIRET',
    street: 'Company address',
    vatId: 'VAT Number (optional)',
    zip: 'Zip',
  },
  fr: {
    addContact: 'Ajouter un contact',
    city: 'Ville',
    companyName: 'Nom de l’entreprise',
    contacts: 'Contacts',
    country: 'Pays',
    deleteContact: 'Supprimer',
    findClientDescription:
      'Trouvez votre client grâce à son nom ou SIRET. Nous récupérons automatiquement ses informations.',
    legalRegistrationNumber: 'Numéro SIRET ou SIREN',
    searchInputLabel: 'Recherchez votre client',
    searchInputPlaceholder: 'Nom, SIREN ou SIRET',
    street: 'Adresse du siège social de l’entreprise',
    vatId: 'N° de TVA (facultatif)',
    zip: 'Code postal',
  },
} as const);

export default locales;
